import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { ToastProvider } from "react-toast-notifications";
import App from "./App";
import WagmiProvider from "./ethers/WagmiProvider";
import { store } from "./redux/store";
import { Buffer } from "buffer";
import Scrollbar from "./components/Scrollbar";
import { Crisp } from "crisp-sdk-web";
// import ApolloProvider from "./apollo/ApolloProvider";
import { SkeletonTheme } from "react-loading-skeleton";

if (typeof window !== "undefined") {
    window.Buffer = Buffer;
}

const token = "021c0a0a-90ff-48ad-b143-70644a0daa34";
Crisp.configure(token);

ReactDOM.render(
    <React.StrictMode>
        <WagmiProvider>
            {/* <ApolloProvider> */}
            <Provider store={store}>
                <ToastProvider
                    newestOnTop={true}
                    placement="bottom-right"
                >
                    <SkeletonTheme baseColor="#1A1D1F" highlightColor="#444">
                        <Scrollbar isPage={true}>
                            <App />
                        </Scrollbar>
                    </SkeletonTheme>
                </ToastProvider>
            </Provider>
            {/* </ApolloProvider> */}
        </WagmiProvider>
    </React.StrictMode>,
    document.getElementById("root")
);
